<template>
  <div v-if="fiscalTaxParameter.ratesVisible">
    <h6 class="mb-1">
      {{ $t('IBS Estadual') }}
    </h6>

    <b-row class="mb-2">
      <b-col md="4">
        <FormulateInput
          id="tax-parameter-ibs-state-percent"
          v-model="fiscalTaxParameter.ibsStatePercent"
          name="tax-parameter-ibs-state-percent"
          type="text-percetage"
          currency="%"
          :precision="5"
          validation="required|number|min:0.0000|max:1"
          :validation-messages="{
            ...mxGetTextPercentageValidationMessages,
          }"
          :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_PERCENT')"
          class="required"
        />
      </b-col>
      <b-col md="4">
        <FormulateInput
          id="tax-parameter-ibs-state-reduction-percent"
          v-model="fiscalTaxParameter.ibsStateReductionPercent"
          name="tax-parameter-ibs-state-reduction-percent"
          type="text-percetage"
          currency="%"
          :precision="5"
          validation="required|number|min:0.0000|max:1"
          :validation-messages="{
            ...mxGetTextPercentageValidationMessages,
          }"
          :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_REDUCTION_PERCENT')"
          class="required"
        />
      </b-col>
      <b-col md="4">
        <FormulateInput
          id="tax-parameter-ibs-state-deferral-percent"
          v-model="fiscalTaxParameter.ibsStateDeferralPercent"
          name="tax-parameter-ibs-state-deferral-percent"
          type="text-percetage"
          currency="%"
          :precision="5"
          validation="required|number|min:0.0000|max:1"
          :validation-messages="{
            ...mxGetTextPercentageValidationMessages,
          }"
          :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_DEFERRAL_PERCENT')"
          class="required"
        />
      </b-col>
    </b-row>

    <h6 class="mb-1 mt-1">
      {{ $t('IBS Municipal') }}
    </h6>
    <b-row>
      <b-col md="4">
        <FormulateInput
          id="tax-parameter-ibs-municipal-percent"
          v-model="fiscalTaxParameter.ibsMunicipalPercent"
          name="tax-parameter-ibs-municipal-percent"
          type="text-percetage"
          currency="%"
          :precision="5"
          validation="required|number|min:0.0000|max:1"
          :validation-messages="{
            ...mxGetTextPercentageValidationMessages,
          }"
          :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_PERCENT')"
          class="required"
        />
      </b-col>
      <b-col md="4">
        <FormulateInput
          id="tax-parameter-ibs-municipal-reduction-percent"
          v-model="fiscalTaxParameter.ibsMunicipalReductionPercent"
          name="tax-parameter-ibs-municipal-reduction-percent"
          type="text-percetage"
          currency="%"
          :precision="5"
          validation="required|number|min:0.0000|max:1"
          :validation-messages="{
            ...mxGetTextPercentageValidationMessages,
          }"
          :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_REDUCTION_PERCENT')"
          class="required"
        />
      </b-col>
      <b-col md="4">
        <FormulateInput
          id="tax-parameter-ibs-municipal-deferral-percent"
          v-model="fiscalTaxParameter.ibsMunicipalDeferralPercent"
          name="tax-parameter-ibs-municipal-deferral-percent"
          type="text-percetage"
          currency="%"
          :precision="5"
          validation="required|number|min:0.0000|max:1"
          :validation-messages="{
            ...mxGetTextPercentageValidationMessages,
          }"
          :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_DEFERRAL_PERCENT')"
          class="required"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { formulateHelper } from '@/mixins'
import { BRow, BCol } from 'bootstrap-vue'
import { mapState } from 'vuex'

export default {
  name: 'FiscalTaxParameterIbsForm',
  components: { BRow, BCol },
  mixins: [formulateHelper],
  computed: {
    ...mapState('pages/invoice/fiscalTaxParameters/fiscalTaxParameterMaintain', [
      'fiscalTaxParameter',
    ]),
  },
}
</script>
